module.exports = __webpack_public_path__ + "img/scene-entry-banner-4.f3756f96.png";